import { type ApolloClient, type NormalizedCacheObject, gql } from '@apollo/client/core';
import type { Query, QueryWebhookSubscriptionAuditLogArgs } from '../../../generated/api.graphql';
import { CONNECTION_METADATA_FIELDS } from '../../connection/Api';
import * as GqlConnection from '../../connection/GqlConnection';
import * as AuditLogEntry from './AuditLogEntry';
import { AUDIT_LOG_ENTRY_FIELDS } from './fragments';

export const PAGE_SIZE = 25;

export const WEBHOOK_SUBSCRIPTION_AUDIT_LOG_QUERY = gql`
  query WebhookSubscriptionAuditLog($subscriptionId: ID!, $first: Int, $after: String) {
    webhookSubscriptionAuditLog(subscriptionId: $subscriptionId, first: $first, after: $after) {
      edges {
        cursor
        node {
          ...AuditLogEntryFields
        }
      }
      pageInfo {
        ...ConnectionMetadataFields
      }
    }
  }
  ${AUDIT_LOG_ENTRY_FIELDS}
  ${CONNECTION_METADATA_FIELDS}
`;

export const fetchWebhookSubscriptionAuditLog = async (
  client: ApolloClient<NormalizedCacheObject>,
  subscriptionId: number,
  after?: string,
): Promise<GqlConnection.GqlConnection<AuditLogEntry.AuditLogEntry>> => {
  const variables: QueryWebhookSubscriptionAuditLogArgs = { subscriptionId: String(subscriptionId), first: PAGE_SIZE };

  if (after) {
    variables.after = after;
  }

  const { data } = await client.query<Pick<Query, 'webhookSubscriptionAuditLog'>>({
    query: WEBHOOK_SUBSCRIPTION_AUDIT_LOG_QUERY,
    fetchPolicy: 'network-only',
    variables,
  });

  return AuditLogEntry.fromGqlConnection(data.webhookSubscriptionAuditLog);
};
